import newRegistersRequests from '../../server/newRegisters';
import { addLoading, removeLoading } from './loading';

export const setRegisters = res => ({
  type: 'GET_NEWREGISTERS',
  newRegisters: res,
});

export const getNewRegistersTable = (limit, skip, search = '', order = '', field = '') => async (dispatch) => {
  if (!search) dispatch(addLoading());
  try {
    const registers = await newRegistersRequests.getNewRegistersTable(limit, skip, search, order, field);
    dispatch(setRegisters(registers));
  } finally {
    if (!search) dispatch(removeLoading());
  }
};

export const getCsvNewRegistersReport = () => async (dispatch) => {
  dispatch(addLoading());
  try {
    await newRegistersRequests.getCsvNewRegistersReport();
  } finally {
    dispatch(removeLoading());
  }
};

export const resendIntegration = register => async (dispatch) => {
  dispatch(addLoading());
  try {
    await newRegistersRequests.resendIntegration(register);
  } finally {
    dispatch(removeLoading());
  }
};

const updateNewRegister = newRegister => async (dispatch) => {
  dispatch(addLoading());
  try {
    await newRegistersRequests.updateNewRegister(newRegister);
  } finally {
    dispatch(removeLoading());
  }
};

export default {
  getNewRegistersTable,
  getCsvNewRegistersReport,
  resendIntegration,
  updateNewRegister,
};
